export default __webpack_public_path__ + "static/Welcome-c149a7a235ffa43b54a1aed8a67676c1.webp";